export function closeModal(){document.getElementById('modalRoot').innerHTML=''}
